import { Box, Typography, useTheme } from '@mui/material';
import { tokens } from 'theme/tokens';

export default function LabelValueBox({
  value,
  label,
  action,
  valueVariant='body1',
  valueFontWeight=600,
  labelVariant='body2',
  labelFontWeight=400,
}) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box sx={{ flex: 1, flexShrink: 0 }}>
      <Typography
        variant={valueVariant}
        fontWeight={valueFontWeight}
        color={colors.neutral[800]}
      >
        {value}
      </Typography>
      <Typography
        variant={labelVariant}
        fontWeight={labelFontWeight}
        color={colors.neutral[500]}
        gutterBottom
      >
        {label} {action}
      </Typography>
    </Box>
  );
};

